/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Segment_EventsInputs */



/**
* | output |
* | --- |
* | "Segment Events" |
*
* @param {Event_Group_Options_Segment_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_segment_events = /** @type {((inputs?: Event_Group_Options_Segment_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Segment_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Segmenter les événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События сегмента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos de segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("细分事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड घटनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos do Segmento")
	return /** @type {LocalizedString} */ ("Segment Events")
});